import { Box, Container } from '@energiebespaarders/symbols';
import type { getAllTopics_allFaqTopics } from '~/types/generated/cms/getAllTopics';
import type { getCategories_allFaqCategories } from '~/types/generated/cms/getCategories';
import type { getFaqItemsByCategory_allFaqItems } from '~/types/generated/cms/getFaqItemsByCategory';
import type { getSubCategories_allFaqCategories } from '~/types/generated/cms/getSubCategories';
import DatoMetaTags from '../DatoCms/DatoMetaTags';
import CategoryOverview from './CategoryOverview';

export interface FAQSubCategory {
  category: getSubCategories_allFaqCategories;
  topics: ReadonlyArray<getAllTopics_allFaqTopics>;
}

export interface CategoryPageProps {
  type: 'category';
  category: getSubCategories_allFaqCategories;
  topics: ReadonlyArray<getAllTopics_allFaqTopics>;
  readonly navbarCategories: ReadonlyArray<getCategories_allFaqCategories>;
  faqItems: ReadonlyArray<getFaqItemsByCategory_allFaqItems>;
}

type CategoryProps = Omit<CategoryPageProps, 'type' | 'navbarCategories'>;

const Category: React.FC<CategoryProps> = ({ category, topics, faqItems }) => {
  const parentCategorySlug = category!.parentCategory?.slug ? category!.parentCategory.slug : '';
  const canonicalUrl = `https://energiebespaarders.nl/faq/${
    parentCategorySlug ? `${parentCategorySlug}/` : ''
  }${category!.slug}`;

  return (
    <>
      <DatoMetaTags metaTags={category.seo} canonicalUrl={canonicalUrl} />
      <Container size="lg" py={10}>
        <Box px={4}>
          <CategoryOverview category={category} topics={topics} faqItems={faqItems} />
        </Box>
      </Container>
    </>
  );
};

export default Category;
